define('OutSystems/ReactWidgets/Popup',["require", "exports", "tslib", "OutSystems/ClientRuntime/Settings", "OutSystems/ReactView/Portal", "OutSystems/ReactView/Widget", "react", "tabbable", "./Utils"], function (require, exports, tslib_1, Settings_1, Portal_1, Widget_1, React, tabbable_1, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Popup = void 0;
    var REACT_CONTAINER_ID = "reactContainer";
    var DIALOG_ARIA_LABEL = "Dialog";
    var ON_ESCAPE_EVENT_NAME = "onEscape";
    var Popup = (function (_super) {
        tslib_1.__extends(Popup, _super);
        function Popup(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.dialogRef = React.createRef();
            _this.previouslyFocusedElement = null;
            _this.updateMainContainerAriaHiddenAttr();
            _this.focusFirstFocusableElement = _this.focusFirstFocusableElement.bind(_this);
            _this.handleKeyDown = _this.handleKeyDown.bind(_this);
            _this.state = { value: props.showPopup };
            return _this;
        }
        Popup_1 = Popup;
        Popup.prototype.componentDidMount = function () {
            if (this.props.showPopup && (0, Settings_1.getEnvParams)().EnableWCAG22) {
                this.previouslyFocusedElement = document.activeElement;
            }
        };
        Popup.prototype.componentWillUnmount = function () {
            this.disableScroll(false);
            this.updateMainContainerAriaHiddenAttr();
            if ((0, Settings_1.getEnvParams)().EnableWCAG22) {
                this.restorePreviousFocus();
            }
        };
        Popup.prototype.UNSAFE_componentWillMount = function () {
            this.disableScroll(this.props.showPopup);
        };
        Popup.prototype.UNSAFE_componentWillUpdate = function (nextProps) {
            this.disableScroll(nextProps.showPopup);
        };
        Popup.prototype.componentDidUpdate = function () {
            var _this = this;
            this.updateMainContainerAriaHiddenAttr();
            if (this.props.showPopup !== this.state.value) {
                var opening = this.props.showPopup && !this.state.value;
                var closing_1 = !this.props.showPopup && this.state.value;
                var wcag22_1 = (0, Settings_1.getEnvParams)().EnableWCAG22;
                if (opening && wcag22_1) {
                    this.previouslyFocusedElement = document.activeElement;
                }
                this.setState({ value: this.props.showPopup }, function () {
                    _this.focusFirstFocusableElement();
                    if (closing_1 && wcag22_1) {
                        _this.restorePreviousFocus();
                    }
                });
            }
        };
        Popup.prototype.restorePreviousFocus = function () {
            var target = this.previouslyFocusedElement;
            this.previouslyFocusedElement = null;
            if (target && typeof target.focus === "function" && document.contains(target)) {
                target.focus();
            }
        };
        Popup.prototype.handleKeyDown = function (event) {
            if (event.key === Utils_1.KeyboardKey.TAB_KEY) {
                this.handleTabTrap(event);
                return;
            }
            if (event.key !== Utils_1.KeyboardKey.ESCAPE_KEY) {
                return;
            }
            var onEscape = this.props.extendedEvents && this.props.extendedEvents[ON_ESCAPE_EVENT_NAME];
            if (onEscape) {
                onEscape();
            }
        };
        Popup.prototype.handleTabTrap = function (event) {
            var dialog = this.dialogRef.current;
            if (!dialog) {
                return;
            }
            var focusables = (0, tabbable_1.tabbable)(dialog);
            if (focusables.length === 0) {
                event.preventDefault();
                dialog.focus();
                return;
            }
            var first = focusables[0];
            var last = focusables[focusables.length - 1];
            var active = document.activeElement;
            var atBoundary = active === dialog || !dialog.contains(active);
            if (event.shiftKey && (active === first || atBoundary)) {
                event.preventDefault();
                last.focus();
            }
            else if (!event.shiftKey && (active === last || atBoundary)) {
                event.preventDefault();
                first.focus();
            }
        };
        Popup.prototype.disableScroll = function (disable) {
            if (disable) {
                document.documentElement.classList.add(Popup_1.DisableScrollClass);
            }
            else {
                document.documentElement.classList.remove(Popup_1.DisableScrollClass);
            }
        };
        Popup.prototype.updateMainContainerAriaHiddenAttr = function () {
            if (this.props.showPopup) {
                document.getElementById(REACT_CONTAINER_ID).setAttribute("aria-hidden", "true");
            }
            else if (document.getElementsByClassName("popup-backdrop").length === 0) {
                document.getElementById(REACT_CONTAINER_ID).removeAttribute("aria-hidden");
            }
        };
        Popup.prototype.focusFirstFocusableElement = function () {
            if (this.props.showPopup) {
                var htmlNode = this.getHTMLNode();
                if (htmlNode) {
                    var element = htmlNode.querySelector("input, button, textarea, select, a");
                    if (element) {
                        element.focus();
                    }
                }
            }
        };
        Popup.prototype.render = function () {
            var _this = this;
            if (this.props.showPopup) {
                var enableWCAG22 = (0, Settings_1.getEnvParams)().EnableWCAG22;
                var popupDialogDivAttributes = tslib_1.__assign({ "data-popup": "", className: "popup-dialog " + this.props.style, role: "dialog", "aria-modal": true }, (enableWCAG22 && { "data-wcag22": "" }));
                this.fillWithBuiltinProperties(popupDialogDivAttributes);
                if (enableWCAG22) {
                    var consumerAttrs = popupDialogDivAttributes;
                    if (!consumerAttrs["aria-label"] && !consumerAttrs["aria-labelledby"]) {
                        popupDialogDivAttributes["aria-label"] = DIALOG_ARIA_LABEL;
                    }
                    if (consumerAttrs["tabIndex"] === undefined && consumerAttrs["tabindex"] === undefined) {
                        popupDialogDivAttributes.tabIndex = -1;
                    }
                    popupDialogDivAttributes.ref = this.dialogRef;
                    var consumerOnKeyDown_1 = popupDialogDivAttributes.onKeyDown;
                    popupDialogDivAttributes.onKeyDown = function (event) {
                        if (consumerOnKeyDown_1) {
                            consumerOnKeyDown_1(event);
                        }
                        if (!event.defaultPrevented) {
                            _this.handleKeyDown(event);
                        }
                    };
                }
                return (React.createElement(Portal_1.Portal, null,
                    React.createElement("div", { onClick: function (e) { return e.stopPropagation(); }, onTouchMove: function (e) { return e.stopPropagation(); }, className: "popup-backdrop", "data-popup-backdrop": "" },
                        React.createElement("div", tslib_1.__assign({}, popupDialogDivAttributes),
                            React.createElement("div", { className: "popup-content" }, this.props.children)))));
            }
            else {
                return null;
            }
        };
        var Popup_1;
        Popup.DisableScrollClass = "popup-disable-scroll";
        Popup = Popup_1 = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], Popup);
        return Popup;
    }(Widget_1.Widget));
    exports.Popup = Popup;
});
//# sourceMappingURL=Popup.js.map;
